import { DateTime } from 'luxon';
import React from 'react';
import { ContentWorkflowTableItem } from '../../workflow-viewer/ContentWorkflowTableDefinitions';

export interface ContentQueryContextState {
  queryTimestamp?: DateTime;
  queryResult?: ContentWorkflowTableItem[];
  queryError?: string;
  isExecutingQuery: boolean;
}
export interface ContentQueryContextData {
  queryState: ContentQueryContextState;
  dispatchQueryState: React.Dispatch<Partial<ContentQueryContextState>>;
}

export const ContentQueryContext = React.createContext<ContentQueryContextData>({
  queryState: { isExecutingQuery: false, queryResult: [] },
  // @ts-expect-error TS2322 - strict migration
  dispatchQueryState: undefined,
});
